export enum UserRoles {
    ADMIN = 1,
    OFFICER = 2,
    USER = 3,
    STAFF = 4,
    SUPER_ADMIN = 5
}

export enum UserConfirmationRoles {
    ISADMIN = 1,
    ISOFFICER = 2,
    ISVILLAGESTAFF = 4
}

export enum AdminPanels {
    // VILLAGE_STAFF_PANEL = 0,
    // OFFICER_PANEL= 1,
    // CAR_DETAILS_PANEL = 2,
    // ADDRESSES_PANEL= 3,
    // REASON_FOR_VIOLATION_PANEL = 4,
    // USERS_AND_ROLES_PANEL = 6,
    // YEAR_CYCLE_PANEL = 5
    USERS_AND_ROLES_PANEL = 0,
    ADDRESSES_PANEL = 1,
    REASON_FOR_PARKING = 2,
    YEAR_CYCLE_PANEL = 3,
    YEAR_PANEL = 4
}

